<div>

  <div class="flex gap-4">
    <div class="flex-1">
      <p-table
        #dtp
        aria-label="Group table"
        class="table-parameters table-simple-paginator"
        [value]="foundGroups"
        [columns]="groupColumns"
        [(selection)]="groupSelectedItems"
        [paginator]="true"
        [sortOrder]="defaultSortOrderGroups"
        [loading]="isLoadingGroups$ | async"
        [defaultSortOrder]="defaultSortOrderGroups"
        [sortField]="defaultSortFieldGroups"
        [totalRecords]="foundGroupsTotalRecords"
        [rows]="amountOfRows"
        [scrollable]="true"
        (onRowSelect)="rowSelectGroups()"
        (onRowUnselect)="rowUnselectGroups()"
        [globalFilterFields]="['displayName']"
        [resetPageOnSort]="true"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th>
              <p-checkbox
                [binary]="true"
                [disabled]="foundGroups && foundGroups.length === 0"
                [(ngModel)]="selectAllStateGroups"
                (onChange)="onChangeSelectAllStateGroups($event)"
              />
            </th>
            @for (col of columns; track col) {
              <th
                [ngStyle]="{ display: col.display }"
                [pSortableColumn]="col.field">
                <span [innerText]='col.header'></span>
                @if (col.field && col.header !== '') {
                  <p-sortIcon
                    [field]="col.field"
                    aria-label="Activate to sort"
                    ariaLabelDesc="Activate to sort in descending order"
                    ariaLabelAsc="Activate to sort in ascending order">
                  </p-sortIcon>
                }
              </th>
            }
          </tr>
          <tr class="header-filter">
            <th></th>
            <th>
              <input
                pInputText type="text"
                (input)="applyFilterGroupTable($event,'displayName', 'contains')"
                placeholder="Search by Group"
                class="ui-column-filter"
              >
            </th>

          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">
              <h7 class="p-my-2">No record found</h7>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>
              <p-tableCheckbox [value]="item" />
            </td>
            <td>{{ item.displayName }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <div class="flex flex-col gap-4 mt-12">
      <p-button
        type="button"
        aria-label="Add Selected"
        icon="pi pi-angle-right"
        [disabled]="disableAssignButton()"
        (click)="assignGroups()"
      />
      <p-button
        type="button"
        aria-label="Remove Selected"
        icon="pi pi-angle-left"
        [disabled]="!userSelectedItems.length"
        (click)="onRemove()"
      />
    </div>

    <div class="flex-1">
      <p-table
        #dtu
        aria-label="Group users table"
        class="table-parameters table-simple-paginator"
        [value]="userGroups"
        [columns]="userGroupColumns"
        [(selection)]="userSelectedItems"
        [sortOrder]="defaultSortOrder"
        [sortField]="defaultSortField"
        [loading]="isLoadingUsers"
        [defaultSortOrder]="defaultSortOrder"
        [totalRecords]="userGroupsTotalRecords"
        [paginator]="true"
        [rows]="amountOfRows"
        [scrollable]="true"
        (onRowSelect)="rowSelectUsers()"
        (onRowUnselect)="rowUnselectUsers()"
        [globalFilterFields]="['displayName']"
        [resetPageOnSort]="true"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th>
              <p-checkbox
                [binary]="true"
                [disabled]="userGroups && userGroups.length === 0"
                [(ngModel)]="selectAllStateUserGroups"
                (onChange)="onChangeSelectAllStateUserGroups($event)">
              </p-checkbox>
            </th>
            @for (col of columns; track col) {
              <th [pSortableColumn]="col.field">
                <div class="flex items-center gap-2">
                  {{ col.header }}
                  @if (col.field && col.header !== '') {
                    <p-sortIcon
                      [field]="col.field"
                      aria-label="Activate to sort"
                      ariaLabelDesc="Activate to sort in descending order"
                      ariaLabelAsc="Activate to sort in ascending order"
                    />
                  }
                </div>
              </th>
            }
          </tr>
          <tr class="header-filter">
            <th></th>
            <th>
              <input pInputText type="text" (input)="applyFilterUserGroupTable($event,'displayName', 'contains')"
                     placeholder="Search by Group" class="ui-column-filter">
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="2">
              <h7 class="p-my-2">No record found</h7>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td>
              <p-tableCheckbox [value]="item" />
            </td>
            <td>{{ item.displayName }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog
  header="Confirmation"
  icon="pi pi-exclamation-triangle"
  appendTo="body"
  key="confirmRemoved"
/>
<p-toast key="removed" position="bottom-left" />
<p-toast key="error" position="bottom-left" />
<p-toast key="success" position="bottom-left" />
